<template>
<div
	class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-2 ps-3 pb-2 mb-3 border-bottom">
	<h4 class="fs-4">Адміністрування організацій</h4>

	<span class="d-inline-block" tabindex="0" data-bs-toggle="tooltip" data-bs-title="створити організацію">
		<button
			type="button"
			class="btn btn-outline-secondary me-4"
			@click="createNewOrganization"
		>
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="" viewBox="0 0 16 16">
				<path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0Z"/>
				<path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3v-2.5a.5.5 0 0 1 .5-.5H8v4H3a1 1 0 0 1-1-1V1Z"/>
				<path d="M4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"/>
			</svg>
		</button>
	</span>
</div>

<div class="table-responsive ps-1" id="stations-table">
	<table class="table table-striped table-hover table-sm">
		<thead>
			<tr class="align-middle">
				<th scope="col" onselectstart="return false;">
					<div class="table-head-coll-wrapper">
						Назва
					</div>
				</th>
				<th scope="col" onselectstart="return false;">
					<div class="table-head-coll-wrapper">
						Адреса
					</div>
				</th>
				<th scope="col" onselectstart="return false;">
					<div class="table-head-coll-wrapper">
						Контакт
					</div>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr v-if="isNoConnectionToServer">
				<td colspan="4"><h5>Немає зв'язку с сервером.</h5></td>
			</tr>
			
			<tr
				class="align-middle"
				v-for="org in sortedOrganizations"
				:key="org._id"
				@click="onOrganizationRowClick(org._id)"
			>
				<td>
					{{ org.title }}
					<svg
						v-if="org.role === 'primary'"
						xmlns="http://www.w3.org/2000/svg"
						width="16"
						height="16"
						fill="currentColor"
						class="bi bi-exclamation text-danger"
						viewBox="0 0 16 16"
					>
						<path d="M7.005 3.1a1 1 0 1 1 1.99 0l-.388 6.35a.61.61 0 0 1-1.214 0L7.005 3.1ZM7 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"/>
					</svg>
				</td>

				<td>
					&nbsp;-&nbsp;
				</td>
				
				<td>
					&nbsp;-&nbsp;
				</td>
			</tr>
		</tbody>
	</table>
</div>
</template>
    
    
<script>
import { useTooltip } from '@/composables/bootstrap-tooltip.js'
import { useAccontStore } from '@/stores/AccountStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { RESOURCE_NAMES, BLANK_ORGANIZATION_ID, readResources } from '@/api/api.js'

	
export default {
	components: {
	},

	props: {
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()

		useTooltip()

		return {
			accountStore,
			stationsStore,
		}
	},

	data() {
		return {
			isNoConnectionToServer: false,
			organizations: [],
		}
	},

	created() {
		// Read all organizations
		this.loadOrganizations()
	},

	mounted() {
		document.title = "Організації"
	},

	methods: {
		// Load all organizations
		async loadOrganizations() {
			const organizations = await readResources(
				RESOURCE_NAMES.organizations,
				this.accountStore.userLogin,
				this.accountStore.userPassword,
				//`embedded={"${null}":1,`
			)

			this.isNoConnectionToServer = organizations.length == 0

			// Remove blank organization from Array
			this.organizations = organizations.filter(org => org._id !== BLANK_ORGANIZATION_ID)
		},

		createNewOrganization() {
			const id = 'new'
			this.$router.push({ name: 'organization', params: { id } })
		},

		onOrganizationRowClick(orgId) {
			const id = String(orgId)
			this.$router.push({ name: 'organization', params: { id } })
		},
	},

	computed: {		
		// Sort station list
		sortedOrganizations () {
			let orgs = this.organizations
			
			// Sorting function
			const sort_func = function (a, b) {
				if (a == b) {
					return 1
				}
				// No sorting
				return 0
			}
			orgs.sort(sort_func.bind(this));

			return orgs
		},
	},
}
</script>
    
    
<style scoped>
.table {
	cursor: pointer;
}
/* Стиль для обгортки заголовка */
.table-head-coll-wrapper {
	display: flex; /* Встановлюємо flex-контейнер */
	align-items: center; /* Вирівнюємо елементи по вертикалі */
	cursor: pointer; /* Додатковий стиль для курсору */
}

/* Додатковий стиль для іконки, якщо потрібно */
.table-head-coll-wrapper svg {
	margin-left: 5px; /* Додатковий відступ між текстом і іконкою */
}
</style>
